import React from "react";
import "./header.css";
import SmallBtn from "../Button/SmallBtn";

export default function Header(props) {
  return (
    <div className="header">
      <div className="title">METAVERS ANALYSIS</div>
    </div>
  );
}
